const zh = {
  header: {
    home: '首页',
    media: '媒体',
    solution: '系统解决方案',
    travel: '全球旅行购',
    recruit: '合作伙伴招募',
    overview: '概述',
    overview_: 'Travel-X面向旅游及旅游零售行业招募合作伙伴，包括品牌、机场、免税商及目的地商户，致力于为合作互博安提供有效的、成本可接受的转化效率。',
    portus: '为目标消费者呈现设计精巧的营销活动，并通过广告投放为航空公司带来稳定的投入产出比。',
    portusPlus: '应用Travel-X的航班行程数据，锁定旅行者(行前、行中或行后)或是常旅客人群，于顶级媒体上达成曝光。',
    portusAir: '为航空公司带来“端到端”的、产品打包和推广方案，为其实现有效的收益增长和无缝的用户体验。',
    portusFin: '基于出行旅行场景、服务于银行移动端的完整解决方案，改善银行用户在旅行中的交互体验。',
    travel_: '“口袋中的全球旅行购物指南”',
    airport: '机场',
    airport_: 'Travel-X通过合作伙伴连接百万级旅行者，并以CPS或佣金形式推广机场内商户。',
    free: '免税店',
    free_: 'Travel-X致力于提升免税店的门店到店旅客量以及线上销售表现。',
    brand: '零售品牌',
    brand_: 'Travel-X为旅游零售品牌提升于中国消费者心中的品牌认知，同时带来透明的广告投放及转化路径。',
    place: '目的地商户',
    place_: 'Travel-X通过撬动合作伙伴的资源，面向中国消费者推广来自于全球的目的地商户。'
  },
  home: {
    travelx_one: 'Travel-X基于数据和技术能力，通过为B端合作伙伴提供综合性解决方案，实现了流量与服务的高效连接，从而构建了网关级平台（Gateway）',
    travelx_two: '公司成立于2016年，目前已形成了“3+1”的业务布局：三套面向B端的解决方案，和一个独立toC品牌。公司累积获得了四轮融资，股东包括双湖资本（家族办公室），并与中国航信设有合资公司。',
    col1: '已经累积的全球航班预订数据',
    col2: '所覆盖的航班旅客预定记录',
    col3: '全球旅行购独立注册用户',
    col4: '中国常旅客覆盖人数',
    solution: '解决方案',
    s1: 'Travel-X依托其数据、技术和商务能力，打造旅行场景的网关级平台，有效',
    s2: '提升商户的获客及转化效率，',
    s3: '有效',
    s4: '改善流量合作伙伴的变现效率及服务能力。',
    solu1: 'Travel-X分别有面向',
    solu2: '航空公司、旅游零售品牌、目的地（目的地营销）、以及金融机构（银行）的解决方案。',
    solution1: '航空公司营销云解决方案。',
    solution2: '航空公司产品打包及推广解决方案。',
    solution3: '数据驱动的、面向旅游及旅游零售客户的数字广告方案。',
    solution4: '服务于开放银行的出行场景全服务解决方案。',
    more: '了解更多',
    travel: '全球旅行购',
    travel1: '全球旅行购是Travel-X旗下to C品牌，定位于',
    travel2: '口袋里的全球购物指南',
    travel3: '，以旅行指南、“行前”旅行购物预订、“行中”出行支付助手和“行后”电商为核心功能，通过整合全球旅游零售商、品牌和顶级供应链资源，以及引入合作伙伴的支付和商户资源，为消费者提供烦扰更少、',
    travel4: '品质和价格更优、选择成本更低的旅行与购物体验。',
    customer_case: '客户案例',
    swiper1: 'Travel-X所提供的PortusFin应用于广发银行信用卡APP「发现精彩」，支持其出行服务板块的用户服务升级，全球旅行购以H5形式入驻广发银行信用卡APP、与广发银行进行线上直播合作，为广发银行用户提供全方位的出行权益体验，并支持其发卡、用户激活等业务目标。',
    swiper2: 'Travel-X为雅诗兰黛集团旅游零售板块提供数字广告服务，PortusPlus解决方案精准定向行前、行中和行后人群，并联动国内的头部旅游零售商落地联合营销活动，极大帮助合作伙伴节约了广告投放成本，提高了广告投放效率。',
    swiper3: 'Travel-X为中国南方航空提供完整的营销系统及营销服务，服务其国内本土会员获取、海外社交媒体营销等业务模块，Portus解决方案为客户提供了包括会员运营、产品运营底层逻辑分析、航司产品分析、航司产品设计、运营方案设计、运营方案执行等支持，同时Travel-X整合自身合作伙伴资源，推动南航拓展异业合作，不断探索多维度全方位的发展方向。',
    swiper4: 'Travel-X与厦门航空进行数据、运营等多维度合作，为厦航提供全年广告投放主题策划与投放方式支持，为航司广告投放模式与广告投放渠道进行创新与拓展。通过新颖趣味的互动模式广告与数据人群筛选能力提高航司广告投放效率。',
    swiper5: 'Travel-X为积家的旅游零售板块提供数字营销服务，利用客户画像与客户出行数据、金融数据、电商数据等，为积家筛选目标客群，进行精准广告投放。',
  },
  footer: {
    portus: '波塔斯（北京）科技有限公司',
    address: '地址：北京市东城区禄米仓胡同71号',
    phone: '电话：',
    mail: '邮箱：',
    follow: '关注我们',
    scan: 'http://travelmall.portus.cn/2023/04/2df08d4c683b4c209cee553d7553fa95.png',
    shanghai: '上海东美在线旅行社有限公司'
  },
  media: {
    media: '媒体解决方案',
    self: '自营媒体',
    self_content: '「全球旅行购」是Travel-X搭建的出行及旅行购物服务平台，聚合全球范围内的住宿、机场、目的地购物和景点等服务与预订资源，整合国内外免税商供应链以提供直邮到家的电商服务，并提供里程、积分支付等会员权益。目前已经入驻多家中国头部商业银行、企业内部平台等。',
    more: '查看更多',
    dataMedia: '数据+媒体',
    dataMediaContent: 'Travel-X是中国头部旅客出行数据整合商，并同步整合了多渠道数据，将数据能力应用于中国头部媒体，提供广告营销服务，以满足品牌方对于品牌营销和效果营销的需求。',
    dataSource: '数据资源',
    overview: '数据概述',
    overview1: 'Travel-X是国内覆盖度最高的旅客航班出行数据提供商，整合了航班时刻、线路、运价、动态以及旅客画像等相关数据。',
    overview2: 'Travel-X整合了其他合作伙伴的数据和资源，形成了更加完整的数据应用系统，以及更广泛更具有深度的渠道触达能力。',
    value: '数据价值',
    realize: 'Travel-X通过分析媒体、航司、免税商提供的数据，可以实现',
    target: '精准投放',
    target_: '应用数据为客户提供个性化推送营销',
    evaluation: '效果评估',
    evaluation_: '将部分数据回传至零售商，匹配零售商数据，评估投放效果并进行人群分析',
    insight: '回溯投放',
    insight_: '将数据用于直播活动的预热投放，长期将引入电商平台的商业化版位',
    lack: '数据稀缺性',
    realize_: 'Travel-X通过分析媒体、航司、免税商提供的数据，可以实现',
    unique: '唯一',
    unique_: 'Travel-X是国内唯一能够读取航班旅客数据的服务商，利用手机设备数据和媒体数据进行匹配，精准定位客群',
    dynamic: '动态',
    dynamic_: 'Travel-X在旅客预定机票之后即可实时读取到数据',
    comprehensive: '海量',
    comprehensive_: 'Travel-X目前每年能够覆盖航班总量的90%',
    DMP: 'DMP+大众媒体',
    DMP_content: 'Travel-X利用自身DMP平台挖掘人群进行产品广告投放。',
    selfSource: '自营媒体资源',
    selfSourceContent: '全球旅行购享有数百万注册用户以及百万级月活数据',
    position: '曝光位置',
    APP: '航司端APP、银行端APP、微信朋友圈、视频号；,其他合作伙伴APP/小程序（大悦城、如家、FESCO）',
    customers: '覆盖客群',
    selfCustomers: '自有客群',
    selfCustomer_: '全球旅行购电商平台的用户',
    partner: '合作渠道客群',
    partner_: '聚合银行/航空公司等渠道的用户；通过合作品牌方、合作平台引流的客群',
    userData: '用户数据',
    userData_: '整合了超过2000万独立用户的画像设备信息，并能够将数据应用于营销的数据授权链条',
    userProfile: '用户画像',
    userProfile_: '独立研发的用户数据分析平台，整合了旅游行业中超过90%的用户相关数据',
    return: '客户回报',
    filter: '精准客群筛选',
    filter_1: 'Travel-X通过独立研发的用户数据平台，整合收集到的数据，导出包含用户特定行为数据的人群信息集合，可应用到多种营销场景中，为用户提供个性化推送服务的同时满足营销需求。',
    filter_2: 'Travel-X通过整合航旅出行人群，可以动态识别已经预定和即将出行的人群，根据航班数据，开展精准营销活动。',
    cover: '目标客群的全媒体覆盖',
    cover_1: 'Travel-X能购以独立H5接入合作伙伴的应用APP中。',
    cover_2: 'Travel-X能够将相关数据应用至第三平台开展进行广告投放。',
    conversion: '交易机会挖掘',
    conversion_1: 'Travel-X与中免集团发布联合营销平台方案，弥补中免集团在品牌、数据方面的稀缺性，打造营销闭环。',
    conversion_2: 'Travel-X具备大数据挖掘和营销服务能力，客户覆盖了航空公司、酒店集团、各大商业银行、各大免税商等国内头部客户和跨国企业客户，具有出色的服务能力。',
  },
  solution: {
    portus: 'Portus：航空公司营销云',
    marketing: '营销科技',
    marketing_: 'Travel-X为中国和世界头部航空公司提供应用于数字营销和会员营销的云计算系统，该系统支持航空公司投放先进的动态广告，即在广告及营销信息中，根据实时用户画像，展示出发地和目的地信息以及实时机票价格，从而实现营销信息的有效性，并为航空公司带来超过10倍至20倍的投入产出比。',
    experience: '你是否正在经历这样的合作伙伴？',
    integrated: '航空公司综合营销服务',
    integrated_: 'Travel-X服务团队基于对航空业的了解，以及相关营销资源、数据资源的整合能力，为国内外航空公司提供营销服务方案全案，覆盖会员运营、数据分析、策划、素材、开发、内容运营等多个维度。',
    portusAir: 'PortusAir：航空公司产品管理',
    suffer: '航空公司，你的产品是否存在以下情况？',
    suffer1: '可打包的附加服务',
    suffer1_: '种类不足',
    suffer2: '只有标准的产品组合方案',
    suffer2_: '难以支持个性化',
    suffer3: '产品销售渠道和',
    suffer3_: '方式有限',
    realize: 'PortusAir为航空公司提供支持其零售化转型的产品管理方案，能够实现：',
    realize1: '自动化和标准化的附加服务接入',
    realize2: '统一的清结算体系',
    realize3: '由GDS提供的渠道及用户数据，搭建产品画像体系',
    realize4: '个性化产品的组合能力',
    portusFin: 'PortusFin银行出行生态解决方案',
    portusFin_: 'PortusFin是Travel-X为商业银行提供的出行场景解决方案数据驱动，服务支撑。',
    service: '服务能力',
    service_: 'PortusFin整合了全球范围内的机票、住宿、机场、目的地购物、目的地景区等服务与产品预定资源，并基于用户画像和出行场景，激活存量用户，提升银行APP活跃度及交易转化率。',
    way: '接入方式',
    way_: 'Travel-X独立搭建H5/小程序页面，入驻银行APP等线上平台，用户可直接通过银行APP登录进入Travel-X所搭建的平台，并享受相关服务。',
    uniqueness: '独特价值',
    uniqueness_: 'PortusFin是国内少数接入了航班旅客行程数据的平台，能够在用户授权后读取用户行程，根据用户的出行场景（行前、行中、行后）和精准画像，提供行程信息和服务预订',
    coop: '合作模式',
    coop1: 'H5入驻手机银行/信用卡/银行其他APP；接入免税集团聚合平台，直连银行收银台，打造交易闭环；',
    coop2: '接入全球旅游零售旗舰店，联动国际品牌，丰富权益/商户内容；',
    coop3: '依托数据能力，识别出行用户，接入适当权益，开展目的地营销；',
    coop4: '联合出行场景流量，嫁接航空公司与行业银行零售业务。',
    coop5: '行后购物可实现免税直供商品包邮到家。',
    recruit: '点击招募合作伙伴',
    solution_img_width: '53vw',
    solution_img_height: '22.4vw',
  },
  travel: {
    platform: '出行服务平台',
    APP: '天行商旅APP',
    APP_: 'Travel-X旗下面向B端客户的差旅平台',
    engine: '智能推荐引擎',
    joint: '联合营销',
    joint_: '全球旅行购利用自身服务能力和平台资源，能够支持多种联合营销模式：开展团购、团购发卡、线下门店（包括快闪店）等线下活动；部分商品可免息分期；通兑航司酒店积分服务等',
    recruit: '合作伙伴招募',
    channelCase: '渠道案例',
    offline: '线下场景',
    engine_width: '59vw',
    engine_height: '40vw'
  },
  recruit: {
    closeLoop: '闭环解决方案',
    adver: '广告-获客',
    adver1: '数字广告：Travel-X是国内领先的、垂直于旅游和旅游零售场景的数字营销服务商，基于稀缺的数据整合能力和广泛的媒体覆盖，为广告主提供完整的数字广告服务。',
    adver2: '动态广告：Travel-X是国内首家应用旅游动态广告的技术服务商，能根据用户的实时搜索和浏览行为，并打通航班和酒店的服务与产品的价格和库存状态，以实时更新广告内容，做到“千人千面”以及“可见即可得”。',
    channel: '渠道引流-获客',
    channel_: 'Travel-X旗下全球旅行购平台入驻银行、企业平台后，能够联动合作伙伴平台的流量资源，为包括航空公司、旅游零售品牌、旅游零售商、目的地等合作伙伴提供品牌曝光、营销活动互动等多种获客机会。',
    platform: '平台-成交',
    platform_: 'Travel-X旗下全球旅行购出行服务平台，通过银行、企业平台等触点，覆盖海量用户及消费者，能够为航空公司、酒店、目的地、品牌及免税商提供有效的成交转化。',
    vip: '会员-粘性',
    vip_: '全球旅行购特色的会员体系，支持用户消费累计航空里程及合作伙伴积分，并可使用积分支付相关产品。此外，Travel-X通过结合实时的动态航班数据Travel-X结合实时的动态航班数据在适当的用户场景下激活用户。',
    beijing: '掌上京彩APP',
    guangfa: '发现精彩APP',
    ICBC: '中国工商银行APP',
    union: '银联云闪付APP',
    CCB: '善融商务APP',
    jinzhou: '锦州银行APP'
  },
  portus: {
    dynamic: '营销技术：动态广告',
    dynamic_: 'Travel-X是国内唯一一家处理航空运价应用于营销的技术企业',
    dashboard: '营销技术：广告投放系统',
    offer: 'Travel-X能够提供如下营销服务',
    marketing1: '线上和线下营销',
    marketing2: '活动的策划执行',
    content1: '内容',
    content2: '输出',
    live1: '直播',
    live2: '运营',
    data1: '数据',
    data2: '分析',
    joint1: '联合',
    joint2: '营销',
    operate: '直播运营',
    popUp: '线下快闪',
    online: '线上营销活动',
    output: '内容输出'
  },
  portusAir: {
    history: '航空公司产品零售的历史沿革',
    history1: '历史遗留问题多，系统基础差',
    history2: '缺乏有竞争力的附加服务',
    history3: '低频消费行为，用户活跃度差',
    history4: '用户属于渠道而非航空公司自己',
    content1: '销售完全依赖渠道（旅行社）',
    content2: '建立了独立网站可以销售产品',
    content3: 'NDC为航空公司销售个性化产品提供了基础',
    content4: '摒弃PNR、EMD等概念，通过自营和渠道销售个性化产品',
    line1: '航空公司分销GDS时代',
    line2: '航空公司分销电商时代',
    line3: '航空公司分销Offer/Order赋能',
    line4: '现代航空公司零售',
    consult: 'Travel-X结论：',
    consultContent: '左侧的进度适用于头部航空公司，但对大部分中国航空公司而言，再去做线上获客的尝试已经意义不大。转型零售只需关心怎么利用好自身优势和价值，在合作伙伴的生态内为合作伙伴创造价值同时提升自身收益能力。',
    system: '航空公司通过产品平台搭建生态体系',
    service: '服务标准：产品和服务的准入管理，交付标准',
    technology: '技术标准：类似于淘宝/美团等平台的标准化的接入方式',
    pay: '支付与结算标准：可接受的支付手段，结算规则等'
  },
  offline: {
    offline: '线下门店',
    offline_: '全球旅行购与银行合作，在商圈、景区等客流量密集区域开设线下店铺，以商品展示、提货、休息和办理金融机构业务为主要服务内容。通过展区和自提点，为用户提供实物商品展示，搭建活动场景，让用户直观感受到权益的价值，提高用户的购物体验。',
    offline1: '全球旅行购联合北京银行中关村分行在八达岭开设线下体验店，用户办卡获得免税商城优惠券和其他权益，并享受额外支付补贴，以此带动发卡。',
    offline2: '目前，已经在北京开设四家体验店，其中包括长期店和快闪店，以线上预订、线下提货为主要业态，部分门店也可进行线下购买。',
    left: '八达岭线下体验店',
    right: '体验店现场图'
  },
  group: {
    coopGroup: '企业内部团购',
    coopGroup_: '全球旅行购联合合作方引入外部大型企业，精选爆款商品直接进入企业为员工提供现场内购服务，并面向潜在客群营销零售产品。',
    content1: '全球旅行购联合北京市的商业银行，在企业内部为员工提供商品团购服务，用户用该银行收银台结算/拥有或办置该银行信用卡获得购物优惠，享受购物后返券。',
    content2: '面向固定客群，如写字楼、产业园区、录区游客，展开团购的推广活动。',
    live: '写字楼、园区等团购现场'
  },
  channel: {
    channel_: '全球旅行购合作伙伴的渠道包括银行、航空公司、酒店集团、小程序、FESCO、大型企业内购平台等',
    bank: '银行合作',
    bank_: '全球旅行购以H5的形式接入银行APP，合作银行包括国有银行和股份制商业银行等',
    travel: '旅行会员计划',
    travel_: 'Travel-X与航空公司、酒店集团等旅行会员计划合作，用户可通过合作伙伴平台享受Travel-X服务',
    partner: '合作伙伴平台',
    partner_: 'Travel-X与商圈零售、地产等合作伙伴合作，用户可通过上述合作伙伴平台跳转至全球旅行购微信小程序',
    popUp: '企业内部平台',
    popUp_: '全球旅行购入驻了国内多家头部国央企的内部福利平台及行业福利平台',
    group: '企业内部团购',
    group_: '全球旅行购联合合作方，为内部员工提供内购服务。例如全球旅行购引入免税商聚合资源，开展线下团购活动'
  },
  picture: {
    dataMedia: 'http://travelmall.portus.cn/2023/04/ad8aa10f66bc4194bdaf8e1a041ce82c.png',
    travelBanner: 'http://travelmall.portus.cn/2023/04/ca4c8f12dcf448dcb701cc495dfdd61f.png',
    partner: 'http://travelmall.portus.cn/2023/04/c8ca78a7c63045b8bd36e8c545236b6a.png',
    recruit: 'http://travelmall.portus.cn/2023/05/d8c8b2c376864dde9b5e29aab32ba40f.png',
    dynamic: 'http://travelmall.portus.cn/2023/04/16dc3d33be964afcacd3ac3245155e5f.png',
    system: 'http://travelmall.portus.cn/2023/04/54372748fb1a412e90ea4673f0fb69cd.png',
    disadvantage: 'http://travelmall.portus.cn/2023/04/b601fa15613c40c6bd1500582ddea663.png',
    advantage: 'http://travelmall.portus.cn/2023/04/a7844d2e764b45798b014faddcf62921.png',
    travel: 'http://travelmall.portus.cn/2023/04/ad60854b9f184ca681b1da0b0a6efa34.png',
    swiper1: 'http://travelmall.portus.cn/2023/04/ef76bf30298a446aa62c313f8def648f.png',
    swiper2: 'http://travelmall.portus.cn/2023/05/9f9dd53ab03c4f64b09e735f03a61892.png',
    swiper3: 'http://travelmall.portus.cn/2023/04/a6edffafa2b74f19a4b4cf0433b833be.png',
    swiper4: 'http://travelmall.portus.cn/2023/04/304830725b8d4d44a52cfe4c19e3313f.png',
    swiper5: 'http://travelmall.portus.cn/2023/04/ee1bfd59866e42118b74916355d70215.png',
    media: 'http://travelmall.portus.cn/2023/04/f877fc172a0f441786c8046785a11a45.png',
    mediaValue: 'http://travelmall.portus.cn/2023/05/24b1544378e147c982c231e73f3cf4e4.png',
    mediaLack: 'http://travelmall.portus.cn/2023/05/1473e240e8ef45c5941d2561c18d7448.png',
    return1: 'http://travelmall.portus.cn/2023/05/fc10e17beed84b5187209d690dcf1c53.png',
    return2: 'http://travelmall.portus.cn/2023/05/8b69790f905b46198eb4ae58641181ee.png',
    return3: 'http://travelmall.portus.cn/2023/05/d228737cf1f04feda86400bc5b72ecc8.png',
    historyImg1: 'http://travelmall.portus.cn/2023/05/3e7480d8d63a43cdb23d7221d7d94ded.png',
    historyImg2: 'http://travelmall.portus.cn/2023/05/9cc839aa81fc46a8b9d8517027c51b3c.png',
    historyImg3: 'http://travelmall.portus.cn/2023/05/209633f40fc2440ab6568120c8d35e65.png',
    historyImg4: 'http://travelmall.portus.cn/2023/05/6c853e7a629447dcb89e533a29d425f0.png'
  },
  style: {
    width: '25.5vw'
  }
}

export default zh